import type { GroupShape } from "@gettactic/map-builder/src/types";
import React from "react";
import { ShapeSvg } from "../ShapeSvg";

export interface GroupSvgProps {
  shape: GroupShape;
}

/** Children are stored relative to the group origin. */
export const GroupSvg: React.FC<GroupSvgProps> = ({ shape }) => (
  <g transform={`translate(${shape.x}, ${shape.y})`}>
    {shape.children.map((child) =>
      child.hidden ? null : (
        <ShapeSvg key={child.id} shape={child} parentGroupColor={shape.color} />
      )
    )}
  </g>
);
